<template>
    <div :class="{ 'ah-text-switch': true, on: value, off: !value }">
        <div
            class="option true"
            @click="
                updateValue(true);
                $emit('change', true);
            "
        >
            {{ trueText }}
        </div>
        <div
            class="option false"
            @click="
                updateValue(false);
                $emit('change', false);
            "
        >
            {{ falseText }}
        </div>
    </div>
</template>
<script>
export default {
    components: {},
    props: {
        trueText: {
            type: String,
            default: '開啟',
        },
        falseText: {
            type: String,
            default: '關閉',
        },
        value: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {};
    },
    computed: {},
    methods: {
        updateValue(val) {
            this.$emit('input', val);
        },
    },
};
</script>
<style lang="scss">
.ah-text-switch {
    display: inline-flex;
    font-size: 8.5pt;
    font-weight: normal;
    $border-color: #e4e4e4;
    $fade-color: #eee;

    &.on {
        .option.true {
            color: #555;
            cursor: default;
        }
        .option.false {
            background-color: $fade-color;
            &:hover {
                background-color: #f6f6f6;
                color: #555;
                cursor: pointer;
            }
        }
    }
    &.off {
        .option.true {
            background-color: $fade-color;
            &:hover {
                background-color: #f6f6f6;
                color: #555;
                cursor: pointer;
            }
        }
        .option.false {
            color: #555;
            cursor: default;
        }
    }

    .option {
        padding: 0 8px;
        height: 28px;
        line-height: 28px;
        border-top: 1px solid $border-color;
        border-bottom: 1px solid $border-color;
        color: #999;
        background-color: #fff;
        transition: 0.2s;

        &.true {
            border-left: 1px solid $border-color;
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
        }
        &.false {
            border-right: 1px solid $border-color;
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
        }
    }
}
</style>
